module.exports = __webpack_public_path__ + "static/media/defaultStepFile.978c482a.png";